import { ButtonTertiary } from "@nova/component-btn"
import { useMemo, useState } from "react"
import * as Icons from "@nova/component-icons"
import { SidePanelPluginActionsNavigator } from "panels/content/side-panel/plugin-actions/SidePanelPluginActionsNavigator"
import { SidePanelPluginActionsRenamer } from "panels/content/side-panel/plugin-actions/SidePanelPluginActionsRenamer"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectUserID } from "user/profile/selectors"
import {
    selectColorFinderFlights,
    selectVideoFlights,
} from "features/entity-caching/flights/selectors"
import { createImageColorFinderFlight } from "features/pubsub/entityActions/flights/imageColorFinder"
import { createVideoColorFinderFlight } from "features/pubsub/entityActions/flights/videoColorFinder"
import { VideoFlight } from "@nova/protobuf"
import { useAddOnRestricted } from "features/data-management/workspace/subscriptions/hooks/useAddOnRestricted"
import { AddOns, SampleDataFlightKey } from "@nova/constants"
import { setActiveFeatureId, setActiveLayerId } from "panels/content/side-panel/slice.new"

export const ColorfinderPluginActionBody = () => {
    const dispatch = useAppDispatch()
    const userId = useAppSelector(selectUserID)
    const flights = useAppSelector(selectColorFinderFlights)
    const defaultname = `Colorfinder ${Object.values(flights).length + 1}`
    const { isRestricted } = useAddOnRestricted(AddOns.Colorfinder)

    const videoFlights = useAppSelector(selectVideoFlights) as VideoFlight[]

    const [nameInput, setNameInput] = useState(defaultname)

    const backButton = useMemo(() => {
        return {
            backTitle: "Cancel",
            onBack: () => {
                dispatch(setActiveFeatureId({ feature: undefined }))
                dispatch(setActiveLayerId({ id: undefined }))
            },
        }
    }, [dispatch])

    if (!userId) return null
    return (
        <SidePanelPluginActionsNavigator {...backButton} layerName={nameInput}>
            {/* Show layer rename field only while a method hasn't been selected yet. */}
            <SidePanelPluginActionsRenamer defaultName={defaultname} onRename={setNameInput} />
            <h5 className="text-gray-0 select-none">Select a Method</h5>
            <div className="flex flex-col gap-1 mt-2">
                <ButtonTertiary
                    key="images"
                    title="Import Images"
                    LeftIcon={Icons.ImportImages}
                    height="2.5rem"
                    onClick={() => {
                        dispatch(
                            createImageColorFinderFlight({
                                data: { createdBy: { userId }, name: nameInput },
                            })
                        )
                    }}
                    clickWillNavigate
                />
                <ButtonTertiary
                    key="video-import"
                    title="Import Video"
                    LeftIcon={Icons.ImportVideo}
                    height="2.5rem"
                    onClick={() => {
                        dispatch(
                            createVideoColorFinderFlight({
                                data: { createdBy: { userId } },
                                context: {
                                    name: nameInput,
                                    sampleDataFlightKey: isRestricted
                                        ? SampleDataFlightKey.vcf2
                                        : undefined,
                                },
                            })
                        )
                    }}
                    clickWillNavigate
                />
                <ButtonTertiary
                    key="video-load"
                    title="Load from Layers"
                    LeftIcon={Icons.Download}
                    height="2.5rem"
                    onClick={() => {
                        dispatch(
                            createVideoColorFinderFlight({
                                data: {
                                    createdBy: { userId },
                                    isCreatedFromVideo: true,
                                },
                                context: {
                                    name: nameInput,
                                },
                            })
                        )
                    }}
                    disabled={videoFlights.length === 0}
                    clickWillNavigate
                />
            </div>
        </SidePanelPluginActionsNavigator>
    )
}
